export default "__VITE_ASSET__BS2WU1Qf__"